export default __webpack_public_path__ + "static/media/back-end.82af4433.png";